import React from "react";
import AppNavbar from "../components/AppNavbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Features from "../components/Features";
import Pricing from "../components/Pricing";
import BlogSection from "../components/BlogSection";
import FaqSection from "../components/FaqSection";
import ContactSection from "../components/ContactSection";
import FooterLegal from "../components/FooterLegal";

const LandingPage = () => (
  <>
    <AppNavbar />
    <Hero />
    <About />
    <Features />
    <Pricing />
    <BlogSection />
    <FaqSection />
    <ContactSection />
    <FooterLegal />
  </>
);

export default LandingPage;
